module.exports = __webpack_public_path__ + "static/media/poorvisibility-icon.3f5e6034.svg";